<template>
  <v-card>
    <v-dialog
      v-model="showingDialog"
      content-class="dialog-fixed-top"
      :max-width="400"
    >
      <v-card>
        <ODialogBar title="Selecione um sistema" @close="dismiss" />
        <div class="maxh-4">
          <v-list>
            <v-list-item
              class="hoverable"
              v-for="row in filteredOrgs"
              :key="row.id"
              @click="confirmApply(row)"
            >
              <v-list-item-title v-html="row.label" />
              <v-list-item-action>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
      </v-card>
    </v-dialog>

    <ORow class="pa-4">
      <span class="headline">Sistemas</span>
      <v-spacer />
      <v-btn icon @click="openDialog">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </ORow>
    <v-divider />
    <v-list>
      <v-list-item v-if="rowOrgs.length < 1">
        <v-list-item-title>(nenhum)</v-list-item-title>
      </v-list-item>
      <v-list-item v-for="org in rowOrgs" :key="org.id" class="hoverable">
        <v-list-item-content>
          <v-list-item-title>
            {{ org.label }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ org.name }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon @click="confirmDelete(org)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { Org, Technician } from '@/models'
import utils from 'oderon-commons/src/utils'

export default {
  props: {
    row: { required: true }
  },
  data() {
    return {
      showingDialog: false,
      allOrgs: []
    }
  },
  computed: {
    filteredOrgs() {
      let result = this.allOrgs.filter(x => {
        if (!utils.hasTag(x.extraInfo, 'PRD')) return false
        if (this.row.orgIds.includes(x.id)) return false
        return true
      })

      return utils.orderBy(result, [['name', 'asc']])
    },

    rowOrgs() {
      return this.row.orgIds.map(orgId => {
        return (
          this.allOrgs.find(x => x.id == orgId) || {
            id: orgId,
            label: '??'
          }
        )
      })
    }
  },
  async mounted() {
    this.allOrgs = await Org.findAll()
  },
  methods: {
    openDialog() {
      this.showingDialog = true
    },
    dismiss() {
      this.showingDialog = false
    },
    async confirmApply(newOrg) {
      let res = await this.$confirm({
        message: `Deseja associar este técnico com o sistema ${newOrg.label}?`,
        okText: 'Sim, associar'
      })

      if (res === true) {
        let newOrgIds = [...this.row.orgIds, newOrg.id]
        this.showingDialog = false

        this.saveAndReload(newOrgIds)
      }
    },
    async confirmDelete(oldOrg) {
      let res = await this.$confirm({
        message: `Deseja desassociar este técnico do sistema ${oldOrg.label}?`,
        okText: 'Sim, deassociar'
      })

      if (res === true) {
        let newOrgIds = this.row.orgIds.filter(x => x != oldOrg.id)
        this.showingDialog = false

        this.saveAndReload(newOrgIds)
      }
    },
    async saveAndReload(orgIds) {
      await this.$loading(() => {
        return Technician.patch(this.row.id, { orgIds })
      })
      this.$emit('reload')
    }
  }
}
</script>

<style></style>